<template>
  <footer class="footer py-12">
    <div class="container mx-auto">
      <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
        <!-- 主办单位 -->
        <div class="footer-section">
          <h3 class="footer-title mb-4">主办单位</h3>
          <p class="footer-text">吉林省软件行业协会</p>
        </div>

        <!-- 联系方式 -->
        <div class="footer-section">
          <h3 class="footer-title mb-4">联系方式</h3>
          <p class="footer-text mb-2">邮箱: 363089437@qq.com</p>
          <p class="footer-text">电话: 0431-80561152</p>
        </div>

        <!-- 友情链接 -->
        <div class="footer-section">
          <h3 class="footer-title mb-4">友情链接</h3>
          <div class="grid grid-cols-1 gap-2">
            <a href="https://www.csia.org.cn/" class="footer-link" target="_blank">中国软件行业协会</a>
            <a href="https://gxt.jl.gov.cn/" class="footer-link" target="_blank">吉林省工业和信息化厅</a>
            <a href="http://www.smejl.cn" class="footer-link" target="_blank">中国中小企业吉林网</a>
            <a href="https://rz.csia.org.cn/?code=251300" class="footer-link" target="_blank">中国软件著作权认证（存证）平台</a>
          </div>
        </div>

        <!-- 二维码 -->
        <div class="footer-section">
          <div class="qr-code-container mx-auto w-32 h-32 bg-white rounded-lg flex items-center justify-center">
            <img src="/images/QRcode.png" alt="二维码" class="w-full h-full p-2" loading="lazy">
          </div>
        </div>
      </div>

      <!-- 版权信息 -->
      <div class="border-t border-gray-200 mt-8 pt-8 text-center text-sm text-gray-600">
        <p>© 2026 吉林省软件行业协会 版权所有 | 吉ICP备2026003054号</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped>
/* 页脚样式 */
.footer {
  font-family: var(--font-family);
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  border-top: 1px solid var(--border);
  position: relative;
  overflow: hidden;
  padding: 60px 0;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 50% 100%, rgba(96, 165, 250, 0.1) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

/* 内容容器 */
.footer .container {
  position: relative;
  z-index: 1;
}

/* 页脚标题 */
.footer-title {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--text-primary);
  margin-bottom: 24px;
  position: relative;
  padding-bottom: 8px;
  transition: color 0.3s ease;
}

.footer-title::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(90deg, var(--accent), transparent);
  box-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
  transition: width 0.3s ease;
}

.footer-title:hover::after {
  width: 60px;
}

/* 页脚文本 */
.footer-text {
  color: var(--text-secondary);
  line-height: 1.6;
  margin-bottom: 12px;
  transition: color 0.3s ease;
}

.footer-text:hover {
  color: var(--accent);
  text-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
}

/* 页脚链接 */
.footer-link {
  color: var(--text-secondary);
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  display: block;
  line-height: 1.6;
  position: relative;
  padding-left: 12px;
}

.footer-link::before {
  content: '→';
  position: absolute;
  left: 0;
  top: 0;
  color: var(--accent);
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform: translateX(-10px);
}

.footer-link:hover {
  color: var(--accent);
  text-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
  /*transform: translateX(4px);*/
}

.footer-link:hover::before {
  opacity: 1;
  /*transform: translateX(0);*/
}

/* 二维码容器 */
.qr-code-container {
  background: var(--surface);
  backdrop-filter: blur(20px) saturate(120%);
  -webkit-backdrop-filter: blur(20px) saturate(120%);
  border-radius: var(--radius-2xl);
  box-shadow: var(--shadow);
  border: 1px solid var(--border);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.qr-code-container:hover {
  /*transform: translateY(-8px) scale(1.05);*/
  box-shadow: 0 15px 35px -10px rgba(37, 99, 235, 0.15), 0 0 20px rgba(96, 165, 250, 0.2);
  border-color: rgba(96, 165, 250, 0.3);
}

.qr-code-container img {
  transition: transform 0.3s ease;
}

.qr-code-container:hover img {
  /*transform: scale(1.1);*/
}

/* 版权信息 */
.footer .border-t {
  border-top: 1px solid var(--border);
  margin-top: 48px;
  padding-top: 24px;
  text-align: center;
  transition: border-color 0.3s ease;
}

.footer .border-t:hover {
  border-color: rgba(96, 165, 250, 0.3);
}

.footer .border-t p {
  color: var(--text-secondary);
  font-size: var(--font-size-sm);
  transition: color 0.3s ease;
}

.footer .border-t p:hover {
  color: var(--accent);
  text-shadow: 0 0 10px rgba(96, 165, 250, 0.5);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .footer {
    padding: 48px 0;
  }

  .footer-section {
    margin-bottom: 32px;
  }

  .footer-title {
    font-size: var(--font-size-base);
    margin-bottom: 24px;
  }

  .qr-code-container {
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .footer {
    padding: 32px 0;
  }

  .footer-title {
    font-size: var(--font-size-lg);
    margin-bottom: 16px;
  }

  .footer-text,
  .footer-link {
    font-size: var(--font-size-sm);
  }

  .footer .border-t {
    margin-top: 32px;
    padding-top: 16px;
  }
}
</style>
